import type { ReactElement } from 'react';
import { Box } from '@ff-it/ui';
import { filterSeparator } from './FilterSeparator.css';

export function FilterSeparator(): ReactElement {
  return <Box as="span" className={filterSeparator} />;
}
